import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./PopUpCheck.scss";

const PopUpCheck = ({ children, buttonAction, active }) => {

  useEffect(() => {
    const timer = setTimeout(() => {
      buttonAction();
    }, 2000);

    return () => clearTimeout(timer);
  }, [active]);

  if (!active) return null;

  return createPortal(
    <div className="PopUpCheck">
      <div className="pop-up">
        <div className="check">
          <span className="game-icons--check-mark" />
        </div>
        <div className="container-pop-up">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PopUpCheck;
